import * as React from "react";

import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";
import { useFormContext } from "react-hook-form";
import { useStore } from "react-redux";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { arRegProfStatusesThunk } from "../../../../../../../store/redux/slice/AppData/arRegProfStatuses";
import { SEARCH_FILTERS_GROUP } from "../../../../../../../config/registers/search/filters/groupsConfig";
import { RootState } from "../../../../../../../store/redux/store";

const ProfQualificationStatusFilter = ({
  xs = 12,
  sm = 6,
  md = 3,
  group = SEARCH_FILTERS_GROUP.PROFESSIONAL_QUALIFICATION,
}) => {
  const thunkState = useAppSelector((state) => {
    return state.AppData.arRegProfStatuses;
  });

  const store = useStore();
  const { getValues } = useFormContext();
  const initValue = getValues("status");

  const getPreviousStateOptionFn = () => {
    const state = store.getState() as RootState;
    const statusCode = state.SearchData.searchTable[group].filtersData.status;
    const options = state.AppData.arRegProfStatuses.data;
    return options.find((element) => element.id === statusCode);
  };

  return (
    <NomenclatureAutocompleteFilter
      initialValue={initValue}
      filter={"status"}
      thunkFn={arRegProfStatusesThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
      xs={xs}
      sm={sm}
      md={md}
    />
  );
};

export default ProfQualificationStatusFilter;
